import React from "react";
import { Link } from "react-router-dom";
import "./logo.scss";
import { useSelector } from "react-redux";
import { getOrg } from "redux/selectors/getOrg";
import _ from 'lodash'

const Logo = () => {
  const member = useSelector(getOrg);
  const org = _.get(member, 'org')

  return <div className="logo">
    <Link to="/admin/stats" className="gap-2">
      {org?.logo && <img src={org.logo || '/media/images/img3.jpg'} height="50px" style={{ width: '50px', objectFit: 'contain' }} />}
      <span className="logo-label">{org?.name || ''} </span>
    </Link>
  </div>
}
export default Logo;
